module.exports = __webpack_public_path__ + "static/img/4.cd45016.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/zh/4.png
// module id = wliJ
// module chunks = 0